import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/travis-med-ai.github.io/travis-med-ai.github.io/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "models"
    }}>{`Models`}</h1>
    <p>{`All available models are managed at `}<a parentName="p" {...{
        "href": "https://github.com/Travis-Med-AI/med-ai-models"
      }}>{`med-ai-models`}</a>{`. `}</p>
    <h2 {...{
      "id": "downloading-new-models"
    }}>{`Downloading New Models`}</h2>
    <p>{`TODO`}</p>
    <h2 {...{
      "id": "submitting-new-models"
    }}>{`Submitting New Models`}</h2>
    <p>{`See our `}<a parentName="p" {...{
        "href": "/contributing/contributing-models"
      }}>{`contributing`}</a>{` section for more information on how to contribute new models.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      